export class LoginViewModel {

    constructor(
        public userName: string,
        public password: string,

        public smsPassword: string) {
    }
    public email: string;
    public clientId : string;
    public phoneNumber: string;
    public appId?: number;
    public rememberMe: boolean ;
}